import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/index.scss'
import Registers from './registers.js'
import Directives from './directives.js'
import i18n from './i18n'
import VueGtag from "vue-gtag";
// import VueTabs from "vue-nav-tabs";
// import "vue-nav-tabs/themes/vue-tabs.css";
// Vue.use(VueTabs);


// Initialize GA
Vue.use(VueGtag, {
  config: { id: "UA-130298789-2" },
  pageTrackerScreenviewEnabled: true,
});

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
//auto register comps
Vue.use(Registers)
//directive functions
Vue.use(Directives)
Vue.prototype.$axios = axios
Vue.config.productionTip = false



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
